export const BRAND_IDS = ['default', 'pierre_fabre'] as const;

export type BrandId = (typeof BRAND_IDS)[number];

/** Turns VITE_BRAND into a pack id; unknown values fail the build instead of shipping the wrong brand. */
export function resolveBrandId(raw: string | undefined): BrandId {
  const id = (raw ?? '').trim() || 'default';
  if (!(BRAND_IDS as readonly string[]).includes(id)) {
    throw new Error(`Unknown VITE_BRAND "${id}". Expected one of: ${BRAND_IDS.join(', ')}`);
  }
  return id as BrandId;
}
